import { Checkbox } from 'primereact/checkbox'

/**
 * Filtro provider per company con pill toggle e checkbox individuali.
 * @param {Object} props - Proprietà componente
 * @param {Array} props.providers - Tuple [providers, setProviders]
 * @param {string} props.company - Nome company provider
 * @returns {JSX.Element} Componente filtro provider
 */
export const Provider = ({ providers: [providers, setProviders], company }) => {
  const companyProviders = providers?.filter((provider) => provider?.company === company) || []
  const allEnabled = companyProviders.every((provider) => !provider?.disabled)

  return (
    <div className="process-pricing-provider">
      <button
        type="button"
        className={`npill ${allEnabled ? 'is-active' : ''}`}
        onClick={() =>
          setProviders(
            providers.map((provider) =>
              provider?.company === company ? { ...provider, disabled: allEnabled } : provider
            )
          )
        }
      >
        {company}
        <span className="npill__count">{companyProviders.length}</span>
      </button>
      <div className="process-pricing-provider__list">
        {companyProviders.map((provider, i) => (
          <label key={i} className="process-pricing-provider__item">
            <Checkbox
              checked={!provider?.disabled}
              onChange={(e) =>
                setProviders(
                  providers.map((prov) =>
                    prov?.provider === provider?.provider ? { ...prov, disabled: !e.checked } : prov
                  )
                )
              }
            />
            <span>{provider?.provider}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
